import React from "react";
import classNames from "classnames";
import { FormattedMessage, Link } from "gatsby-plugin-intl";

const Card = ({ className, text, to }) => {
  return (
    <div className="w-full lg:w-1/2 mb-3 lg:mb-0">
      <Link
        to={to}
        className={classNames(
          className,
          "flex flex-col relative px-2 cursor-pointer transition-all ease-in-out duration-300 hover:opacity-50 text-2xl rtl:text-3xl font-semibold"
        )}
      >
        <FormattedMessage id={text} />
      </Link>
    </div>
  );
};

export default Card;
